export default "__VITE_ASSET__DVQ7anLU__"